import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      loadingLegalDocuments: 'legalDocuments/loading',
      legalDocuments: 'legalDocuments/legalDocuments'
    })
  },
  methods: {
    ...mapActions({
      setLegalDocuments: 'legalDocuments/setLegalDocuments',
      setLoading: 'legalDocuments/setLoading',
      setMobileDialogLoading: 'profile/accountSettings/setMobileDialogLoading'
    }),
    async getLegalDocument(category, typeName) {
      let requestedDocument = this.legalDocuments[category]
        ? this.legalDocuments[category].find(
            document =>
              document.typeName === typeName &&
              document.languageCode.toLowerCase() === this.$i18n.locale &&
              document.regionCode.toLowerCase() === this.$domainRegion
          )
        : undefined;
      if (requestedDocument) {
        return requestedDocument;
      } else {
        this.setLoading(true);
        this.setMobileDialogLoading(true);
        return await this.$http
          .get(`/v3/legal-documents?category=${category}&languageCode=${this.$i18n.locale}`)
          .then(data => {
            this.setLegalDocuments({
              category,
              data
            });
            return data.find(
              document =>
                document.typeName === typeName &&
                document.languageCode.toLowerCase() === this.$i18n.locale &&
                document.regionCode.toLowerCase() === this.$domainRegion
            );
          })
          .catch(error => {
            this.handleError({ error, code: '0x00000060' });
          })
          .finally(() => {
            this.setLoading(false);
            this.setMobileDialogLoading(false);
          });
      }
    }
  }
};
